export type ProjectStatusTag = 'active' | 'completed' | 'on_hold' | 'cancelled';

// Map project statuses directly to GenericTag's own dedicated status
// values (it already has first-class colors for active/on_hold/cancelled/
// completed -- no need to alias them through unrelated tags like
// approved/pending/rejected).
//
// `projects.status` is nullable in the database (default 'active'), so a row can arrive with no status at all: that, an empty string and any value this
// list does not know show as 'active' instead of breaking the whole table.
export function mapStatusToTag(status: string | null | undefined): ProjectStatusTag {
  switch (String(status ?? '').trim().toLowerCase()) {
    case 'completed':
      return 'completed';
    case 'on_hold':
      return 'on_hold';
    case 'cancelled':
      return 'cancelled';
    default:
      return 'active';
  }
}
